let children = [];

//codigo edgar
children.push({
  path: "/cadenasuministros/transportistas",
  name: "SPC_CARRIER",
  component: () => import("../views/SupplyChain/Transport/SpcCarriers.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Cadena de Suministros", disabled: true },
      { text: "Transporte", href: "/cadenasuministros/transportistas" },
    ],
  },
});

children.push({
  path: "/cadenasuministros/infracciones",
  name: "SPC_TRAFV",
  component: () => import("../views/SupplyChain/TrafficViolation/SpcTrafficViolations.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Cadena de Suministros", disabled: true },
      { text: "Infracciones de Conductores", href: "/cadenasuministros/infracciones" },
    ],
  },
});

// children.push({
//     path: "/cadenasuministros/VisitasConInsumosNoPermitidos",
//     name: "ATS_VISITSNA",
//     component: () =>
//         import ("../views/cadenasuministros/TechnicalVisitSNA/TechnicalVisitSNAVG.vue"),
//     meta: {
//         authenticated: true,
//         breadcrumb: [
//             { text: "Inicio", href: "/#/" },
//             { text: "Asistencia Técnica", disabled: true },
//             { text: "Visitas con Insumos no Permitidos", href: "/asistenciatecnica/Visitas con Insumos no Permitidos" },
//         ],
//     },
// });

export { children };
